module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-head"
  }, [_c('nav', {
    staticClass: "navbar is-primary has-shadow",
    class: {
      'is-warning': _vm.isHom
    }
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_vm._m(0), (_vm.isHom) ? _c('div', {
    staticClass: "navbar-warning"
  }, [_c('a', {
    staticClass: "navbar-item"
  }, [_vm._v("HOMOLOGAÇÃO")])]) : _vm._e(), _c('div', {
    staticClass: "navbar-burger burger",
    on: {
      "click": _vm.toggleMenuVisibility
    }
  }, [_c('span'), _c('span'), _c('span')])]), _c('div', {
    staticClass: "navbar-menu is-hidden-tablet",
    class: {
      'is-active': _vm.menuShown
    }
  }, [_c('a', {
    staticClass: "navbar-item",
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("Desconectar")])]), _c('div', {
    staticClass: "navbar-menu"
  }, [_c('div', {
    staticClass: "navbar-end"
  }, [_c('b-dropdown', [_c('a', {
    staticClass: "navbar-item",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_c('span', [_vm._v(_vm._s(_vm.$parent.user.name))]), _c('b-icon', {
    attrs: {
      "icon": "arrow_drop_down"
    }
  })], 1), _c('b-dropdown-item', {
    staticClass: "has-text-primary",
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("Desconectar")])], 1)], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "navbar-item logo"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/logo.png"),
      "alt": "THEPES Logo",
      "height": "10"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75a6eb52","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 404
// module chunks = 56